import React from 'react';
import ContentMasteryTestRepeatRateSummary from './ContentMasteryTestRepeatRateSummary';
import { ContentMasteryRepeatRateListService } from '../../services/ContentListService';
import { observer } from 'mobx-react';

const ContentMasteryTestRepeatRateSummaryContainer = () => {
  const summary = ContentMasteryRepeatRateListService.getChart();
  return (
    <ContentMasteryTestRepeatRateSummary
      isLoading={
        ContentMasteryRepeatRateListService.fetchCurrent.fetching ||
        ContentMasteryRepeatRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentMasteryRepeatRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentMasteryTestRepeatRateSummaryContainer);
